import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  Tr,
  Td,
  Th,
  TdImp
} from '../fmComponents/fmMicrosoftLicensing/css';
import EN from '../../../EN.json';
import { formatCurrency } from '../../utils/currencyFormatter';
import { managedDetectionResponse } from '../../utils/constant';

const FMProducts = ({ orderData }) => {
  const {
    srtDashboardFM: { managedItServicesFM, microsoftLicensingFM }
  } = EN;
  const {
    productSelectionFM,
    microsoftLicensingData: {
      selections: microsoftlicensingSelections = []
    } = {},
    managedItServicesSummary: {
      additionalCharges = [],
      charges: managedItServices = [],
      totalMonthlyCharges = 0
    } = {},
    discountValue,
    oneTimeDiscountValue,
    managedDetectionResponseData = {},
    overrideOnetimeDiscountValue,
    overrideMonthlyDiscountValue,
    appliedDiscountId,
  } = orderData;
  const {
    onboardingFee = 0,
    totalPrice = 0
  } = managedDetectionResponseData;
  const totals = useMemo(() => {
    let totalCostSum = 0;
    let totalPriceSum = 0;
    microsoftlicensingSelections.forEach(item => {
      totalCostSum += item.totalCost;
      totalPriceSum += item.totalPrice;
    });
    return {
      totalCost: totalCostSum,
      totalPrice: totalPriceSum
    };
  }, [microsoftlicensingSelections]);
  const itServicesTotal = useMemo(() => {
    let additionalChargesSum = 0;
    let managedItChargesSum = 0;
    let additionalOnboardingFee = 0;
    additionalCharges.forEach(item => {
      additionalChargesSum += item.total;
    });
    managedItServices.forEach(item => {
      managedItChargesSum += item.total;
    });
    additionalOnboardingFee = additionalChargesSum;
    additionalChargesSum = additionalChargesSum - (oneTimeDiscountValue || 0);
    return {
      totalAdditionalCharges: additionalChargesSum,
      totalManagedItCharges: managedItChargesSum,
      additionalOnboardingFee
    };
  }, [additionalCharges, managedItServices]);

  const additionalServicesTotalMonthlyCharges = useMemo(() => {
    const additionalServices = managedItServices.filter(item =>
      item.name.includes('Additional Service')
    );
    return additionalServices.reduce(
      (total, service) => total + service.total,
      0
    );
  }, [managedItServices]);

  const mdrPricing = {
    mdrOnboardingFee: managedDetectionResponseData.onboardingFee || 0,
    mdrTotalPrice: managedDetectionResponseData.totalPrice || 0
};


  // const managedServicesTotalMonthlyCharges = useMemo(() => {
  //   const managedServices = managedItServices.filter(
  //     item => !item.name.includes('Additional Service')
  //   );
  //   return managedServices.reduce((total, service) => total + service.total, 0);
  // }, [managedItServices]);

  const totalMonthlyChargesWithoutAdditionalServices =
    totalMonthlyCharges - additionalServicesTotalMonthlyCharges;

  const grandTotal =
    totalMonthlyChargesWithoutAdditionalServices +
    additionalServicesTotalMonthlyCharges +
    mdrPricing.mdrTotalPrice +
    (totals ? totals.totalPrice : 0) -
    (discountValue ? parseFloat(discountValue) : 0);

  return (
    <div>
      {productSelectionFM.includes(managedItServicesFM[0]) && (
        <>
          {managedItServices && managedItServices.length && (
            <Table>
              <Th>Managed IT Services</Th>
              <Th>Qty</Th>
              {managedItServices
                .filter(item => !item.name.includes('Additional Service'))
                .map(({ name, quantity }) => (
                  <Tr key={name}>
                    <Td>{name}</Td>
                    <Td>{quantity}</Td>
                  </Tr>
                ))}
              <Tr>
                <TdImp colSpan={1}>Total Monthly Charges</TdImp>
                <TdImp>
                  {formatCurrency(totalMonthlyChargesWithoutAdditionalServices)}
                </TdImp>
              </Tr>
            </Table>
          )}
          {/* MDR Summary */}
          {productSelectionFM.includes(managedDetectionResponse) &&
            managedDetectionResponseData &&
            Object.keys(managedDetectionResponseData).length && (
              <Table>
                <Th>{managedDetectionResponse}</Th>
                <Th>Qty</Th>

                <Tr key={managedDetectionResponseData.mdrData.name}>
                  <Td>{managedDetectionResponseData.mdrData.name}</Td>
                  <Td>{managedDetectionResponseData.numberOfUsers}</Td>
                </Tr>

                <Tr>
                  <TdImp colSpan={1}>Total Monthly Charges</TdImp>
                  <TdImp>
                    {formatCurrency(managedDetectionResponseData.totalPrice)}
                  </TdImp>
                </Tr>
              </Table>
            )}
          {productSelectionFM.includes(microsoftLicensingFM[0]) && (
            <>
              {!!microsoftlicensingSelections.length && (
                <Table>
                  <Th>Microsoft Licensing Subscriptions</Th>
                  <Th>Cost</Th>
                  <Th>Price Per Unit</Th>
                  <Th>Qty</Th>
                  <Th>Total Charge Per Month For 1 Year</Th>
                  {microsoftlicensingSelections.map(
                    ({
                      subscriptionLineOption,
                      cost,
                      price,
                      qtyOfLicenses,
                      totalPrice
                    }) => (
                      <Tr key={subscriptionLineOption}>
                        <Td>{subscriptionLineOption}</Td>
                        <Td>{formatCurrency(cost)}</Td>
                        <Td>{formatCurrency(price)}</Td>
                        <Td>{qtyOfLicenses}</Td>
                        <Td>{formatCurrency(totalPrice)}</Td>
                      </Tr>
                    )
                  )}
                  <Tr>
                    <TdImp colSpan={4}>Total Monthly Charges</TdImp>
                    <TdImp>{formatCurrency(totals.totalPrice)}</TdImp>
                  </Tr>
                </Table>
              )}
            </>
          )}
          {managedItServices &&
            managedItServices.length &&
            managedItServices.some(item =>
              item.name.includes('Additional Service')
            ) && (
              <Table>
                <Th>Additional Services</Th>
                <Th>Qty</Th>
                <Th>Monthly Charges</Th>
                {managedItServices
                  .filter(item => item.name.includes('Additional Service'))
                  .map(({ name, quantity, total }) => (
                    <Tr key={name}>
                      <Td>{name}</Td>
                      <Td>{quantity}</Td>
                      <Td>{formatCurrency(total)}</Td>
                    </Tr>
                  ))}
                <Tr>
                  <TdImp colSpan={2}>Monthly Additional Services</TdImp>
                  <TdImp>
                    {formatCurrency(additionalServicesTotalMonthlyCharges)}
                  </TdImp>
                </Tr>
              </Table>
            )}
          {additionalCharges && additionalCharges.length && (
            <Table>
              <Th>Additional Charges</Th>
              <Th>One Time Charges</Th>
              {additionalCharges.map(({ name, total }) => (
                <Tr key={name}>
                  <Td>{name}</Td>
                  <Td>{formatCurrency(total)}</Td>
                </Tr>
              ))}
              {productSelectionFM.includes(managedDetectionResponse) &&
                managedDetectionResponseData &&
                Object.keys(managedDetectionResponseData).length && (
                  <Tr key={managedDetectionResponseData.feeData.name}>
                    <Td>
                      {managedDetectionResponse}{' '}
                      {managedDetectionResponseData.feeData.name}
                    </Td>
                    <Td>
                      {formatCurrency(
                        mdrPricing.mdrOnboardingFee
                      )}
                    </Td>
                  </Tr>
                )}
              <Tr>
                <TdImp colSpan={1}>Total One Time Charges</TdImp>
                <TdImp>
                  {formatCurrency(itServicesTotal.additionalOnboardingFee+mdrPricing.mdrOnboardingFee)}
                </TdImp>
              </Tr>
            </Table>
          )}
        </>
      )}
      {appliedDiscountId && (
        <Table>
          <Th>Discount</Th>
          <Th>Total Discount Per month for 1 year</Th>
          <Tr>
            <TdImp>Total Monthly Discount</TdImp>
            <TdImp>${overrideMonthlyDiscountValue || discountValue}</TdImp>
          </Tr>
          <Tr>
            <TdImp>Total One Time Discount</TdImp>
            <TdImp>${overrideOnetimeDiscountValue || oneTimeDiscountValue}</TdImp>
          </Tr>
          <Tr>
            <TdImp>Approval Id</TdImp>
            <TdImp>{appliedDiscountId}</TdImp>
          </Tr>
        </Table>
      )}
      <Table>
        <Th>Order Summary</Th>
        <Th>Total Charges</Th>
        {managedItServices && managedItServices.length && (
          <Tr>
            <TdImp>Monthly Managed IT Services</TdImp>
            <TdImp>
              {formatCurrency(totalMonthlyChargesWithoutAdditionalServices)}
            </TdImp>
          </Tr>
        )}
        {productSelectionFM.includes(microsoftLicensingFM[0]) && (
          <>
            {!!microsoftlicensingSelections.length && (
              <Tr>
                <TdImp>Monthly Microsoft Licensing</TdImp>
                <TdImp>{formatCurrency(totals.totalPrice)}</TdImp>
              </Tr>
            )}
          </>
        )}
        {managedItServices &&
          managedItServices.length &&
          managedItServices.some(item =>
            item.name.includes('Additional Service')
          ) && (
            <Tr>
              <TdImp>Monthly Additional Services</TdImp>
              <TdImp>
                {formatCurrency(additionalServicesTotalMonthlyCharges)}
              </TdImp>
            </Tr>
          )}
        {productSelectionFM.includes(managedDetectionResponse) &&
          managedDetectionResponseData &&
          (Object.keys(managedDetectionResponseData).length >0) && (
            <Tr key={managedDetectionResponseData.mdrData.id}>
              <TdImp>Monthly {managedDetectionResponse} </TdImp>
              <TdImp>
                {formatCurrency(mdrPricing.mdrTotalPrice) || 0}
              </TdImp>
            </Tr>
          )}
        {discountValue && (
          <Tr>
            <TdImp>Monthly Discount</TdImp>
            <TdImp>-${discountValue}</TdImp>
          </Tr>
        )}
        {additionalCharges &&
          additionalCharges.length &&
          additionalCharges.map(({ name, total }) => (
            <Tr key={name}>
              <TdImp>{name}</TdImp>
              <TdImp>{formatCurrency(total)}</TdImp>
            </Tr>
          ))}
        {productSelectionFM.includes(managedDetectionResponse) &&
          managedDetectionResponseData &&
          Object.keys(managedDetectionResponseData).length && (
            <Tr key={managedDetectionResponseData.feeData.name}>
              <TdImp>
                {managedDetectionResponse}{' '}
                {managedDetectionResponseData.feeData.name}
              </TdImp>
              <TdImp>
                {formatCurrency(managedDetectionResponseData.onboardingFee)}
              </TdImp>
            </Tr>
          )}
        {oneTimeDiscountValue && (
          <Tr>
            <TdImp>One Time Discount</TdImp>
            <TdImp>-${oneTimeDiscountValue}</TdImp>
          </Tr>
        )}
        <Tr>
          <TdImp>Total Monthly Charges (CAD)</TdImp>
          <TdImp>{formatCurrency(grandTotal)}</TdImp>
        </Tr>
        <Tr>
          <TdImp>Total One Time Charges (CAD)</TdImp>
          <TdImp>
            {formatCurrency(
              itServicesTotal.totalAdditionalCharges + mdrPricing.mdrOnboardingFee
            )}
          </TdImp>
        </Tr>
      </Table>
      {orderData &&
        orderData.remediationProject &&
        orderData.remediationProject.toUpperCase() === 'YES' && (
          <p style={{ marginTop: '10px' }}>
            <strong style={{ fontWeight: 600 }}>
              Estimated Remediation Project ({orderData.remediationCurrency}):
            </strong>{' '}
            $
            {orderData.remediationMonthlyCharge
              ? orderData.remediationMonthlyCharge
              : orderData.remediationOneTimeCharge}{' '}
            ({orderData.remediationMonthlyCharge ? 'Monthly' : 'One Time'})
          </p>
        )}
    </div>
  );
};

FMProducts.propTypes = {
  orderData: PropTypes.shape({
    productSelectionFM: PropTypes.arrayOf(PropTypes.string),
    microsoftLicensingData: {
      selections: PropTypes.array
    },
    managedItServicesSummary: {
      additionalCharges: PropTypes.array,
      charges: PropTypes.array
    },
    discountValue: PropTypes.string,
    discountApprovalId: PropTypes.string,
    oneTimeDiscountValue: PropTypes.string,
    overrideMonthlyDiscountValue: PropTypes.string,
    overrideOnetimeDiscountValue: PropTypes.string,
    appliedDiscountId: PropTypes.string,
  }).isRequired
};

export default FMProducts;
